<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="'90%'"
    :height="700"
    :title="popupConfig.title"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      #default
      location="after"
      locate-in-menu="auto"
      :v-if="popupConfig.formMode !== 'create' && FriendlyStatus"
    >
      <gc-status-chip :status="FriendlyStatus" v-if="FriendlyStatus" />
    </DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <gc-form
        :key="popupConfig.formKey"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="model"
        :form-mode="popupConfig.formMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
        v-if="IsFormLoaded"
      />
    </div>

    <div style="background-color: white" class="wo-data-details">
      <DxToolbar class="wo-so-toolbar" v-if="IsFormLoaded">
        <DxItem
          :options="{
            width: 'auto',
            dataSource: [
              {
                id: 0,
                text: 'Add In',
                visible: IsAddInFeatureEnabled,
              },
              {
                id: 1,
                text: 'Sales Orders',
              },
              {
                id: 2,
                text: 'Materials',
              },
              {
                id: 3,
                text: 'Releases',
                visible:
                  popupConfig.formMode === 'review' &&
                  FriendlyStatus != 'Draft',
              },
            ],
            selectedIndex: this.selectedTabIndex,
            onItemClick: handleTabClick,
          }"
          location="before"
          widget="dxTabs"
        />
        <DxItem
          :options="{
            icon: 'plus',
            onClick: setSoLineModel,
          }"
          location="before"
          locate-in-menu="auto"
          widget="dxButton"
          :visible="getAddSOLineBtnVisibility"
        />
      </DxToolbar>

      <div class="wo-so-lines">
        <!-- Add Ins Grid  -->
        <dx-data-grid
          v-if="
            IsFormLoaded &&
            this.selectedTabIndex === 0 &&
            this.IsAddInFeatureEnabled
          "
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :key-expr="'ID'"
          :pager="{ visible: false }"
          :columns="getAddInGridColumns"
          :data-source="getAddInLocalDataSource"
          :row-alternation-enabled="true"
          :height="280"
          :ref="'wo-add-in-grid'"
          @selection-changed="onAddInSelectionChanged"
          @content-ready="onContentReady"
          @editor-preparing="onEditorPreparing"
          @row-updated="addInRowUpdated"
          @initialized="onGridInitialized"
        >
          <DxEditing
            :allow-deleting="popupConfig.formMode != 'review'"
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <!-- <DxRowDragging
            :allow-reordering="popupConfig.formMode !== 'review'"
            :show-drag-icons="true"
            :on-reorder="onRowReorder"
          />-->
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Sale Orders Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded && this.selectedTabIndex === 1"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getSalesGridColumns"
          :data-source="getLocalDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: getAddSOLineBtnVisibility ? 'multiple' : 'none',
          }"
          :height="280"
          :ref="'wo-so-line-grid'"
          @selection-changed="onSoListSelectionChanged"
          @content-ready="onContentReady"
          @editor-preparing="onEditorPreparing"
        >
          <DxEditing
            :allow-deleting="false"
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <DxRowDragging
            :allow-reordering="popupConfig.formMode !== 'review'"
            :show-drag-icons="true"
            :on-reorder="onRowReorder"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Meterials Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded && this.selectedTabIndex === 2"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getWorkOrderMaterialColumns"
          :data-source="workOrderMaterialDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: 'none',
          }"
          :height="280"
          :ref="'wo-meterials-grid'"
          @content-ready="onContentReady"
        >
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Release Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded && this.selectedTabIndex === 3"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getReleaseColumns"
          :data-source="ReleaseDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: 'none',
          }"
          :height="280"
          :ref="'wo-release-grid'"
          @content-ready="onContentReady"
        >
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <template #product-um-template="{ data }">
            <div v-if="data.value > 0">
              <a @click="onProdQtyClicked(data)">{{ data.text }}</a>
            </div>
            <GcDecimal v-else :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>
      </div>
    </div>

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />

    <gcPopupWorkOrderSoLinesVue
      :popupConfig="soPopupConfig"
      :add-selected-so-lines="addSelectedSoLines"
      :pre-selected-items="soLinesDataSource._array"
      v-if="soPopupConfig.visible"
    />

    <gcPopupWorkOrderReleaseInfo
      :popupConfig="releasePopupInfo"
      :onHide="releasePopupHide"
    />
  </DxPopup>
</template>
<script>
import { TransactionReportService } from "@/_services/api/reports/transaction-report.service";
import ApiService from "@/_services/api/api.service";
import { getGlobalField } from "@/_store/helpers";
import { b64toBlob } from "@/_helpers/pdf/pdf-helper";

import { WorkOrderService } from "../_services/api/production/work-order.service";
import { UserService } from "../_services/api/settings/user/user.service";
import SettingsService from "../_services/api/settings/graycorp/settings.service";
import { DefaultCompanyBranchDivisionService } from "../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../_services/storage";
import { mapGetters } from "vuex";
import gcPopupWorkOrderSoLinesVue from "./gc-popup-work-order-so-lines.vue";
import ArrayStore from "devextreme/data/array_store";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import { DxRowDragging } from "devextreme-vue/data-grid";
import gcPopupWorkOrderReleaseInfo from "./gc-popup-work-order-release-info";

import salesFormulas from "../_helpers/formulas/sales-formulas";
const { calculateStockUMQty, calculateSalesUMQty } = salesFormulas;

const productEntryBase = {
  ID: 0,
  ItemCode: "",
  Description: "",
  SalesUM: "",
  StockUM: "",
  OnHand: 0,
  AddInStockUMQty: 0,
  IsSelected: false,
  OnHandSalesUMQty: 0,
  AddInSalesUMQty: 0,
  SalesUMConversion: 1,
  Available: 0,
  AvailableSalesUMQty: 0,
  OriginalAvailable: 0,
  OriginalAvailableSalesUMQty: 0,
  Note: "",
};

function countLineBreaks(text) {
  return (text.match(/\n/g) || []).length;
}

export default {
  mixins: [DataGridMixin],
  components: {
    gcPopupWorkOrderSoLinesVue,
    DxRowDragging,
    gcPopupWorkOrderReleaseInfo,
  },
  data() {
    return {
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
      FriendlyStatus: undefined,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
        MTSQuantity: 0,
        SOQuantity: 0,
        ReleasedQty: 0,
        AddInSalesUMQuantity: 0,
        AddInStockUMQuantity: 0,
      },
      AddInSalesUM: "KG",
      AddInSalesUMConversion: 1,
      AddInStockUM: "KG",
      IsAddInFeatureEnabled: false,
      IsFormLoaded: false,
      soPopupConfig: {
        visible: false,
      },
      soLinesDataSource: new ArrayStore({
        key: ["SalesOrderCode", "SalesOrderLine"],
        data: [],
      }),
      addInDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      workOrderMaterialDataSource: new ArrayStore({
        key: ["RecordId"],
        data: [],
      }),
      selectedRowsData: [],
      selectedBOMData: undefined,
      selectedProdData: undefined,
      primaryProductData: undefined,
      selectedTabIndex: 0,
      changes: [],
      addInProdFilter: [],
      productDataSourceItems: [],
      WorkOrderAddInFinishedGoodType: undefined,
      WorkOrderAddInFinishedGoodAssociation: undefined,
      saveAsDraft: false,
      releasePopupInfo: {
        isPopupShow: false,
        dataModel: {},
      },
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "WorkOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    if (this.popupConfig.calendarDate) {
      this.model.Required = new Date(this.popupConfig.calendarDate);
    }

    if (
      this.popupConfig.workOrderCode &&
      (this.popupConfig.formMode === "review" ||
        this.popupConfig.formMode === "copy")
    ) {
      this.showLoading(true);
      // const response = await WorkOrderService.getByCode(
      //   this.popupConfig.workOrderCode
      // );
      // const workOrderDetail = response.data.value[0];
      const workOrderDetail = this.dataModel;
      // this.dataModel = { ...workOrderDetail };

      this.model.ReleasedQty = workOrderDetail.ActualQty;
      this.model.BomCode = workOrderDetail.BomCode;
      this.model.Branch = workOrderDetail.BranchCode;
      this.model.Code = workOrderDetail.Code;
      this.model.Comments = workOrderDetail.Comment;
      this.model.CompanyCode = workOrderDetail.CompanyCode;
      this.model.Division = workOrderDetail.DivisionCode;
      this.model.Product = workOrderDetail.ProductCode;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.MTSQuantity = workOrderDetail.MTSQuantity;
      this.model.SOQuantity = workOrderDetail.SalesOrderStockUMQuantity;

      this.auditModel.createdBy = this.dataModel.CreatedBy;
      this.auditModel.dateCreated = this.dataModel.DateCreated;
      this.auditModel.changedBy = this.dataModel.ChangedBy;
      this.auditModel.dateChanged = this.dataModel.DateChanged;

      this.primaryProductData = await this.getProductDataForAddIn(
        workOrderDetail.ProductCode,
        workOrderDetail.BranchCode
      );

      if (this.popupConfig.formMode === "copy") {
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
      } else {
        this.model.QuoteCode = workOrderDetail.QuoteCode;
        this.model.Required = workOrderDetail.ShipDate;
        this.model.Scheduled = workOrderDetail.ScheduledDate;
      }

      if (this.popupConfig.formMode !== "copy")
        this.FriendlyStatus = this.dataModel.FriendlyStatus;

      const statusConditions = {
        Cancel:
          this.dataModel.FriendlyStatus !== "Active" &&
          this.dataModel.FriendlyStatus !== "Draft",
        Reopen:
          this.dataModel.FriendlyStatus !== "Completed" &&
          this.dataModel.FriendlyStatus !== "Cancelled",
        Complete: this.dataModel.FriendlyStatus !== "In Production",
      };

      if (this.FriendlyStatus === "Draft") this.popupConfig.isEditable = true;

      this.getToolbarMenuItems.forEach((element) => {
        if (statusConditions[element.menuText] !== undefined) {
          element.disabled = statusConditions[element.menuText];
        }

        if (
          !FeatureStorage.checkPermission(this.applicationFeatureCode, "create")
        )
          element.disabled = true;
      });

      if (this.popupConfig.formMode === "copy")
        this.addNewLineIntoProductEntry();
      else {
        await this.getWorkOrderAddIns(workOrderDetail.Code);
        await this.getWOSalesOrderLines(workOrderDetail.Code);
        await this.getWorkOrderMaterialList(workOrderDetail.Code);
      }

      this.IsAddInFeatureEnabled = await this.addInFeatureEnabled();
      if (!this.IsAddInFeatureEnabled) this.selectedTabIndex = 1;

      this.IsFormLoaded = true;

      this.$nextTick(async () => {
        await this.updateHeaderAddInValues(workOrderDetail.BomCode);
        this.calculateAddInHeaderValues();
        this.showLoading(false);
      });
    } else {
      this.showLoading(true);
      DefaultCompanyBranchDivisionService.getDefault().then((result) => {
        const defaultData = result.data.value[0];
        this.model.CompanyCode = defaultData.CompanyCode;
      });

      this.IsAddInFeatureEnabled = await this.addInFeatureEnabled();
      if (!this.IsAddInFeatureEnabled) this.selectedTabIndex = 1;

      if (this.popupConfig.soLines) {
        this.IsFormLoaded = true;
        if (this.selectedTabIndex != 1) this.selectedTabIndex = 1;
        this.model.Required = null;

        if (this.popupConfig.BomCode) {
          await WorkOrderService.getBOMByCode(this.popupConfig.BomCode).then(
            (res) => {
              if (res.data.value.length > 0) {
                this.model.BomCode = res.data.value[0].Code;
                this.model.Product = res.data.value[0].ProductCode;
                this.model.Branch = res.data.value[0].BranchCode;
                this.model.Division = res.data.value[0].DivisionCode;
                this.model.Comments = res.data.value[0].Comment;
              }
            }
          );
        }
      } else this.IsFormLoaded = true;
      this.$nextTick(async () => {
        this.onShown();

        if (this.popupConfig.soLines) {
          setTimeout(async () => {
            await this.addSelectedSoLines([...this.popupConfig.soLines]);
            this.showLoading(false);
          }, 500);
        } else this.showLoading(false);
      });
    }

    if (this.popupConfig.formMode === "create") {
      this.addNewLineIntoProductEntry();
    }
  },
  methods: {
    releasePopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },
    onGridInitialized(e) {
      if (this.popupConfig.formMode !== "review" && this.selectedTabIndex === 0)
        setTimeout(() => {
          this.$nextTick(() => {
            this.reSizeGrid(e.component);
          });
        }, 100);
    },
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();

      // this.$nextTick(() => {
      //   component.refresh(true);
      // });
    },
    addInRowUpdated() {
      this.calculateAddInHeaderValues();
    },
    reFocusOnQty(currentRowData, dataField) {
      let dataGrid = this.$refs["wo-add-in-grid"].instance;
      let rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
      if (rowIndex != -1) {
        setTimeout(() => {
          this.focusOnEditableCell(rowIndex, dataField);
        }, 10);
      }
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onFocusIn) {
        let func = e.editorOptions.onFocusIn;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onFocusOut) {
        let func = e.editorOptions.onFocusOut;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onFocusOut = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onInput) {
        let func = e.editorOptions.onInput;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onInput = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.dataField && e.dataField == "ItemCode") {
        e.editorName = "dxSelectBox";
      }

      if (e.dataField && e.dataField == "Comment") {
        e.editorName = "dxTextArea";
      }

      if (this.selectedTabIndex === 0) {
        if (e.dataField && e.dataField == "ItemCode") {
          e.editorName = "dxSelectBox";
        }
      }

      if (this.selectedTabIndex === 1)
        if (e.dataField && e.dataField == "Note") {
          e.editorName = "dxTextArea";
        }
    },

    onEnterItemCode(e, lineData) {
      if (e.event.key == "Enter" && lineData) {
        setTimeout(() => {
          if (lineData && !lineData.data.ItemCode) {
            // eslint-disable-next-line no-console
            console.log("Clicked on a field other than the Item Code Field");
          } else this.focusOnEditableCell(lineData.rowIndex, "RequiredByDate");
        }, 100);
      }

      if (e.event.keyCode == 9 && e.event.shiftKey) {
        e.event.preventDefault();
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "ItemCode";
      if (!this.getDataGridInstance) return;
      var dataGrid = this.getDataGridInstance;

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    async productCodeFocusIn(e) {
      e.event.target.select();
    },
    addNewLineIntoProductEntry(data, type) {
      let maxID = 10000;

      let dataObj = Object.assign({ ...productEntryBase });
      if (data) {
        dataObj = Object.assign({ IsCopyLine: false, IsNewLine: true }, data);
      }
      dataObj.ID = maxID;

      if (this.addInDataSource._array.length != 0) {
        maxID = Math.max(...this.addInDataSource._array.map((e) => e.ID));
        dataObj.ID = ++maxID;
      }

      this.addInDataSource.insert(dataObj);

      if (type) {
        let dataGrid = this.$refs["wo-add-in-grid"].instance;
        dataGrid.refresh().then(() => {
          let rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);

          if (rowIndex != -1) {
            this.focusOnEditableCell(rowIndex, "ItemCode");
          }
        });
      }
    },
    async addInFeatureEnabled() {
      return FeatureStorage.checkPermission("WorkOrderAddIn", "review");
    },
    handleTabClick(e) {
      this.selectedTabIndex = e.itemIndex;

      if (e.itemData.text === "Sales Orders") {
        this.setSoLineSelection();
      }
    },
    onRowReorder(e) {
      let itemData = e.itemData;

      const toIndex = e.toIndex;
      const fromIndex = e.fromIndex;
      const newTasks = [...this.soLinesDataSource._array];

      newTasks.splice(fromIndex, 1);
      newTasks.splice(toIndex, 0, itemData);

      this.soLinesDataSource._array = newTasks;

      this.$nextTick(() => {
        let instance = this.$refs["wo-so-line-grid"].instance;
        if (instance) instance.refresh();
      });
    },
    async getWorkOrderAddIns(workOrderCode) {
      await WorkOrderService.getWorkOrderAddIns(workOrderCode).then((res) => {
        if (res !== null) {
          res.data.value.forEach((element, index) => {
            element.ItemCode = element.ProductCode;
            element.ItemDescription = element.ProductDescription;
            element.ID = index + 1;
            this.addInDataSource.insert(element);
          });
        }
      });
    },
    async getWOSalesOrderLines(code) {
      await WorkOrderService.getWOSOLines(code).then((res) => {
        res.data.value.forEach((element) => {
          element.SalesUMQuantity = element.SalesOrderSalesUMQuantity;
          element.StockUMQuantity = element.SalesOrderStockUMQuantity;
          element.SalesOrderShipDate = new Date(element.SalesOrderShipDate.replace("Z", ""));
          element.IsSelected = true;
          this.soLinesDataSource.insert(element);
        });
      });
    },
    async getWorkOrderMaterialList(code) {
      await WorkOrderService.getWorkOrderMaterialList(code).then((res) => {
        if (res !== null) {
          res.data.value.forEach((element) => {
            this.workOrderMaterialDataSource.insert(element);
          });
        }
      });
    },
    setSoLineModel() {
      this.selectedTabIndex = 1;
      this.soPopupConfig.ProductInfo = this.selectedProdData;
      this.soPopupConfig.visible = true;
      this.setSoLineSelection();
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      // if (this.dataModel) {
      //   this.FriendlyStatus = this.dataModel.FriendlyStatus;
      // }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      setTimeout(() => this.setFocusOnField("BomCode"), 700);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    /**
     * Preview PDF Report
     */
    async onPreviewPDF() {
      if (this.applicationFeatureCode) {
        this.showLoading(true);
        var response;
        await TransactionReportService.getByFeatureCode("ReportWorkOrder")
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$alert("Report repx not found", "Error");
            return;
          });

        var report = undefined;
        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);

          let link = `/api/GetReportPdf?reportLocation=${report.Location}`;

          report.Parameters.forEach((element) => {
            let globalField = { ...getGlobalField(element.screenField) };

            if (globalField) {
              link += `&${globalField.dataField}=${this.dataModel.Code}`;
            }
          });

          await ApiService.get(link)
            .then((res) => {
              const blob = b64toBlob(res.data, "application/pdf");
              const blobUrl = URL.createObjectURL(blob);
              this.showLoading(false);

              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: blobUrl,
              }).click();
            })
            .catch((error) => {
              this.$logger.debug("ExportToPdf Error ", error);
              this.showLoading(false);
            });
        }
      }
    },

    /**
     * On Value Changed
     * @param e
     */
    async onBomValueChanged(e) {
      if (!e.event) return;

      let instance = e.component;

      if (e.value) {
        let selectedItem = instance
          .getDataSource()
          .items()
          .find((x) => x.Code === e.value);

        if (!selectedItem) {
          await WorkOrderService.getBOMByCode(e.value).then((res) => {
            selectedItem = res.data.value[0];
          });
        }

        if (!selectedItem) return;

        await this.updateHeaderAddInValues(e.value);

        if (this.model.Product !== selectedItem.ProductCode) {
          this.updateFormValues("Product", selectedItem.ProductCode);
        }

        if (this.model.SOQuantity != 0) {
          if (selectedItem.BatchSize > this.model.SOQuantity) {
            this.model.Quantity = selectedItem.BatchSize;
            this.model.MTSQuantity =
              this.model.Quantity - this.model.SOQuantity;
          } else this.Quantity = this.model.MTSQuantity + this.model.SOQuantity;
        } else {
          this.model.Quantity =
            selectedItem.BatchSize > 0 ? selectedItem.BatchSize : 1;
          // this.model.MTSQuantity = this.model.Quantity;
        }
        this.updateFormValues("Branch", selectedItem.BranchCode);
        this.updateFormValues("Division", selectedItem.DivisionCode);
        this.updateFormValues("Comments", selectedItem.Comment);

        this.selectedBOMData = selectedItem;

        this.primaryProductData = await this.getProductDataForAddIn(
          selectedItem.ProductCode,
          selectedItem.BranchCode
        );
      } else {
        this.model.Product = null;
        this.model.Comments = null;
        this.model.Branch = null;
        this.model.Division = null;
        this.primaryProductData = undefined;

        if (this.model.SOQuantity === 0) {
          this.model.Quantity = 0;
          this.model.MTSQuantity = 0;
        }
      }
    },

    async getProductDataForAddIn(productCode, branchCode) {
      let productData = await WorkOrderService.getProductDataForAddInDataSource(
        productCode,
        branchCode
      );

      if (!productData.data || productData.data.value.length === 0) return null;

      return productData.data.value[0];
    },
    async updateHeaderAddInValues(bomCode) {
      let result = await WorkOrderService.getBomUnitOfMeasure(bomCode);

      if (result.data.value.length > 0) {
        let bomUOM = result.data.value[0];

        if (bomUOM) {
          this.AddInSalesUM = bomUOM.UnitOfMeasureCode;
          this.AddInSalesUMConversion = bomUOM.Conversion;

          const form =
            this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
          form.beginUpdate();
          form.itemOption("AddInStockUMQuantity", "label", {
            text: `Add In (${this.AddInStockUM})`,
          });

          form.itemOption("AddInSalesUMQuantity", "label", {
            text: `Add In (${this.AddInSalesUM})`,
          });
          form.endUpdate();
        }
      }
    },
    onEditPopupHandler() {
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;
      if (this.dataModel.FriendlyStatus === "In Production")
        setTimeout(() => this.setFocusOnField("Comments"), 50);
      else setTimeout(() => this.setFocusOnField("Required"), 50);
      this.addNewLineIntoProductEntry();

      setTimeout(() => {
        this.$nextTick(() => {
          if (this.selectedTabIndex === 0) {
            if (!this.$refs["wo-add-in-grid"]) return;
            let grid = this.$refs["wo-add-in-grid"].instance;
            grid.refresh();
          } else {
            if (!this.$refs["wo-so-line-grid"]) return;
            let grid = this.$refs["wo-so-line-grid"].instance;

            let IDs = [];
            this.soLinesDataSource._array.forEach((element) => {
              IDs.push({
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              });
            });

            grid.selectRows(IDs, true);
          }
        });
      }, 10);
    },

    setSoLineSelection() {
      this.$nextTick(() => {
        if (!this.$refs["wo-so-line-grid"]) return;
        let grid = this.$refs["wo-so-line-grid"].instance;

        if (grid) {
          let IDs = [];
          this.soLinesDataSource._array.forEach((element) => {
            if (element.IsSelected) {
              IDs.push({
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              });
            }
          });

          grid.refresh().then(() => {
            grid.selectRows(IDs, true);
          });
        }
      });
    },
    onDraftSave() {
      this.saveAsDraft = true;
      this.onSavePopupHandler();
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {
      if (this.model.BomCode === "" || this.model.BomCode === null) {
        await this.$alert("Bom Code Required", "Validation Error");
        this.setFocusOnField("BomCode");
      } else if (this.model.Product === "" || this.model.Product === null) {
        await this.$alert("Product Code Required", "Validation Error");
        this.setFocusOnField("BomCode");
      } else if (this.model.Required === null) {
        await this.$alert("Required Date Required", "Validation Error");
        this.setFocusOnField("Required");
      } else if (this.model.Branch === "" || this.model.Branch === null) {
        await this.$alert("Branch Required", "Validation Error");
        this.setFocusOnField("Branch");
      } else if (this.model.Division === "" || this.model.Division === null) {
        await this.$alert("Division Required", "Validation Error");
        this.setFocusOnField("Division");
      } else if (this.model.Quantity === 0) {
        await this.$alert(
          "WO Quantity should be greater than 0.0000",
          "Validation Error"
        );
        this.setFocusOnField("Division");
      } else {
        const payload = {
          Code: this.model.Code,
          QuoteCode: this.model.QuoteCode,
          DateIn: new Date(this.model.Scheduled).toSaveDate(),
          RequiredDate: new Date(this.model.Required).toSaveDate(),
          CompanyCode: this.model.CompanyCode,
          BranchCode: this.model.Branch,
          DivisionCode: this.model.Division,
          BomCode: this.model.BomCode,
          ProductCode: this.model.Product,
          Comment: this.model.Comments,
          ItemQty: this.model.Quantity.roundNumber(4),
          Username: UserService.getUsername(),
          WorkOrderSalesOrderLines: [],
          WorkOrderAddIns: [],
          MTSQty: this.model.MTSQuantity.roundNumber(4),
        };

        if (this.saveAsDraft) payload.Status = "D";
        else payload.Status = "A";

        // Getting the instance like this results in an error because at a time there is only one grid instance is available (SS). Therefore changing the logic
        // to handle the selected rows data for the so line grid with a IsSelected data field.

        // let instance = this.$refs["wo-so-line-grid"].instance;
        // if (instance) {
        //   selectedRowsData = instance.getSelectedRowsData();
        // }

        let selectedRowsData = this.soLinesDataSource._array.filter(
          (x) => x.IsSelected
        );

        let mtsLine = selectedRowsData.filter(
          (x) => x.SalesOrderCode === 0 && x.SalesOrderLine === 0
        );
        let soLines = selectedRowsData.filter(
          (x) => x.SalesOrderCode !== 0 && x.SalesOrderLine !== 0
        );

        if (this.$refs["wo-add-in-grid"]) {
          let instance = this.$refs["wo-add-in-grid"].instance;
          if (instance) await instance.saveEditData();
        }

        if (this.$refs["wo-so-line-grid"]) {
          let instance = this.$refs["wo-so-line-grid"].instance;
          if (instance) await instance.saveEditData();
        }

        soLines.map((item, index) => {
          let lineItem = {
            WorkOrderCode: this.model.QuoteCode,
            SalesOrderCode: item.SalesOrderCode,
            SalesOrderLine: item.SalesOrderLine,
            SalesOrderStockUMQuantity: item.StockUMQuantity,
            Position: index + 1,
            SalesOrderSalesUMQuantity: item.SalesUMQuantity,
            Note: item.Note,
          };

          payload.WorkOrderSalesOrderLines.push(lineItem);
        });

        mtsLine.map((item) => {
          let lineItem = {
            WorkOrderCode: this.model.QuoteCode,
            SalesOrderCode: item.SalesOrderCode,
            SalesOrderLine: item.SalesOrderLine,
            SalesOrderStockUMQuantity: item.SalesOrderStockUMQuantity,
            Position: payload.WorkOrderSalesOrderLines.length + 1,
            SalesOrderSalesUMQuantity: item.SalesOrderSalesUMQuantity,
            Note: item.Note,
          };

          payload.WorkOrderSalesOrderLines.push(lineItem);
        });

        // selectedRowsData = [];
        // instance = this.$refs["wo-add-in-grid"].instance;
        // if (instance) {
        //   selectedRowsData = instance.getSelectedRowsData();
        // }
        let addInlines = this.addInDataSource._array.filter(
          (x) => x.AddInSalesUMQty > 0 && x.AddInStockUMQty > 0
        );

        addInlines.map((item) => {
          let lineItem = {
            WorkOrderCode: this.model.Code,
            ProductCode: item.ItemCode,
            SalesUM: item.SalesUM,
            StockUM: item.StockUM,
            SalesOrderLine: item.SalesOrderLine,
            AddInStockUMQty: item.AddInStockUMQty.roundNumber(4),
            AddInSalesUMQty: item.AddInSalesUMQty.roundNumber(4),
            RecordId: item.RecordId,
          };

          payload.WorkOrderAddIns.push(lineItem);
        });

        try {
          this.showLoading(true);
          const result = await WorkOrderService.save(payload);
          this.$notify(
            `Work order #${result.data.Code} is successfully ${
              this.popupConfig.formMode === "create" ? "created" : "updated"
            }`,
            "success"
          );
          this.showLoading(false);
          this.saveCallBack();
        } catch (e) {
          this.saveAsDraft = false;
          this.showLoading(false);
          this.displayServerError(e, "Save Failed");
        }
      }
    },

    /**
     * Set Focus on Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      this.saveAsDraft = false;
      if (
        this.$refs["gc-header-form"] &&
        this.popupConfig.formMode !== "review"
      ) {
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
          .getEditor(dataField)
          .focus();
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },

    async resetEditedData() {
      let workOrderDetail = this.dataModel;

      this.model.QuoteCode = workOrderDetail.QuoteCode;
      this.model.Comments = workOrderDetail.Comment;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.Required = workOrderDetail.ShipDate;
      this.model.Scheduled = workOrderDetail.ScheduledDate;
    },

    /**
     * On Copy Work Order
     */
    onCopyWorkOrderHandler() {
      let dataGrid = undefined;

      if (this.IsAddInFeatureEnabled) {
        this.addInDataSource.clear();
        this.addNewLineIntoProductEntry();

        if (this.selectedTabIndex === 0) {
          dataGrid = this.$refs["wo-add-in-grid"].instance;
        }
      }
      this.soLinesDataSource.clear();
      this.workOrderMaterialDataSource.clear();

      if (this.selectedTabIndex === 1) {
        dataGrid = this.$refs["wo-so-line-grid"].instance;
      }

      if (this.selectedTabIndex === 2) {
        dataGrid = this.$refs["wo-meterials-grid"].instance;
      }

      if (dataGrid) dataGrid.refresh(true);

      this.$nextTick(() => {
        this.calculateAddInHeaderValues();
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
        this.FriendlyStatus = undefined;
        this.popupConfig.title = "Create Work Order";
        this.popupConfig.secondaryTitle = undefined;
        this.popupConfig.formMode = "copy";
        this.popupConfig.hideOnOutsideClick = false;
        this.popupConfig.formKey++;
      });
    },

    /**
     * On Cancel Work Order
     */
    async onCancelWorkOrderHandler() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this work order?",
        "Cancel Work Order"
      );

      if (confirmCancel) {
        this.showLoading(true);
        await WorkOrderService.cancelWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Cancelled`,
                "success"
              );
            this.showLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Cancel Work Order Failed");
          });
      }
    },

    /**
     * On Reopen Work Order Handler
     */
    async onReopenWorkOrderHandler() {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this work order?",
        "Re-Open Work Order"
      );

      if (confirmReOrder) {
        this.showLoading(true);
        await WorkOrderService.reopenWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Re-Opened.`,
                "success"
              );
            this.showLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Re-Open Work Order Failed");
          });
      }
    },

    /**
     * On Complete Work Order Handler
     */
    async onCompleteWorkOrderHandler() {
      let confirmComplete = await this.$confirm(
        "Do you want to complete this work order?",
        "Complete Work Order"
      );

      if (confirmComplete) {
        this.showLoading(true);
        await WorkOrderService.completeWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Completed`,
                "success"
              );
            this.showLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Complete Work Order Failed");
          });
      }
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    /**
     * add selected so list from so model to wo model
     * @param soItems - selected items
     */
    addSelectedSoLines(soItems) {
      let IDs = [];

      soItems.forEach((element) => {
        if (element.SalesUMQty) element.SalesUMQuantity = element.SalesUMQty;
        if (element.StockUMQty) element.StockUMQuantity = element.StockUMQty;

        element.SalesOrderShipDate = new Date(element.ShipDate);

        element.IsSelected = true;
        this.soLinesDataSource.insert(element).then(() => {
          IDs.push({
            SalesOrderCode: element.SalesOrderCode,
            SalesOrderLine: element.SalesOrderLine,
          });
        });
      });

      setTimeout(() => {
        this.$nextTick(() => {
          if (!this.$refs["wo-so-line-grid"]) return;
          let instance = this.$refs["wo-so-line-grid"].instance;
          if (instance)
            instance.refresh().then(() => {
              instance.selectRows(IDs, true);
            });
        });
      }, 10);
    },

    // eslint-disable-next-line no-unused-vars
    async onAddInSelectionChanged(e) {
      this.calculateAddInHeaderValues();
    },
    /**
     * WO model so list grid item selected
     */
    async onSoListSelectionChanged(e) {
      await (async () => {
        for (const element of e.selectedRowsData) {
          if (element.Refetch && element.SalesOrderCode !== 0) {
            const res = await WorkOrderService.getWorkOrderSalesOrderDetailLine(
              element.SalesOrderCode,
              element.SalesOrderLine
            );
            if (res.data.value.length > 0) {
              element.StockUMQuantity = res.data.value[0].StockUMBackorderQty;
              element.SalesUMQuantity = res.data.value[0].SalesUMBackorderQty;
              element.IsSelected = true;
              element.Refetch = false;
            }
          }
        }
      })();

      this.selectedRowsData = e.selectedRowsData;
      let currentDeselectedRowKeys = e.currentDeselectedRowKeys;

      if (currentDeselectedRowKeys.length > 0) {
        currentDeselectedRowKeys.forEach((element) => {
          if (element.SalesOrderCode !== 0)
            this.soLinesDataSource.update(
              {
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              },
              {
                IsSelected: false,
                Refetch: true,
              }
            );
        });
      }

      let Quantity = 0;
      let SOQuantity = 0;
      let MTSQuantity = 0;

      const calculateQuantities = (rows) => {
        const mtsLines = rows.filter(
          (x) => x.SalesOrderCode === 0 && x.SalesOrderLine === 0
        );
        const soLines = rows.filter(
          (x) => x.SalesOrderCode !== 0 && x.SalesOrderLine !== 0
        );

        const MTSQuantity = mtsLines.reduce(
          (prev, curr) => prev + curr.StockUMQuantity,
          0.0
        );
        const SOQuantity = soLines.reduce(
          (prev, curr) => prev + curr.StockUMQuantity,
          0.0
        );

        return { MTSQuantity, SOQuantity };
      };

      if (this.popupConfig.formMode === "edit") {
        ({ MTSQuantity, SOQuantity } = calculateQuantities(e.selectedRowsData));

        if (SOQuantity === 0 && MTSQuantity === 0) {
          if (
            this.selectedBOMData &&
            this.selectedBOMData.BatchSize > SOQuantity
          ) {
            Quantity = this.selectedBOMData.BatchSize;
            MTSQuantity = Quantity - SOQuantity;
          }
        } else {
          Quantity = MTSQuantity + SOQuantity;
        }
      } else {
        if (this.selectedRowsData.length > 0) {
          SOQuantity = this.selectedRowsData.reduce(
            (prev, curr) => prev + curr.StockUMQuantity,
            0.0
          );

          if (
            this.selectedBOMData &&
            this.selectedBOMData.BatchSize > SOQuantity
          ) {
            Quantity = this.selectedBOMData.BatchSize;
          } else {
            Quantity = this.model.MTSQuantity + SOQuantity;
          }

          MTSQuantity = Quantity - SOQuantity;
        } else {
          if (this.selectedBOMData && this.selectedBOMData.BatchSize > 0) {
            Quantity = this.selectedBOMData.BatchSize;
          } else {
            Quantity = 1;
          }
          MTSQuantity = Quantity;
        }
      }

      if (
        Quantity < this.model.ReleasedQty &&
        this.dataModel.FriendlyStatus === "In Production"
      ) {
        if (MTSQuantity === 1) MTSQuantity = 0;
        Quantity = this.model.ReleasedQty + MTSQuantity;
      }

      if (this.popupConfig.formMode !== "review") {
        const form =
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
        form.beginUpdate();
        form.updateData("Quantity", Quantity);
        form.updateData("MTSQuantity", MTSQuantity);
        form.updateData("SOQuantity", SOQuantity);
        form.endUpdate();
      }
    },
    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    calculateAddInHeaderValues() {
      let addInStockUMQty = 0;
      let addInSalesUMQty = 0;

      this.addInDataSource._array.forEach((element) => {
        if (element.AddInStockUMQty > 0) {
          addInStockUMQty += element.AddInStockUMQty;
        }
      });

      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData("AddInStockUMQuantity", addInStockUMQty);

      addInSalesUMQty = (
        addInStockUMQty / this.AddInSalesUMConversion
      ).roundNumber(4);

      form.updateData("AddInSalesUMQuantity", addInSalesUMQty);

      form.endUpdate();
    },

    onContentReady(e) {
      if (this.selectedTabIndex === 0) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Add In",
            message: "Select Products to Add In to this Work Order",
          },
        });
      } else if (this.selectedTabIndex === 1) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Sales Orders",
            message: "No orders linked with this Work Order",
          },
        });
      } else if (this.selectedTabIndex === 3) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Releases",
            message: "No Production Release has been made to this Work Order",
          },
        });
      }
    },

    /**
     * WO Qty value changed
     * @param e - event
     */
    async onQuantityValueChanged(e) {
      if (!e.event) return;

      const showAlertAndReset = async (message, field) => {
        await this.$alert(message, "Validation Error");
        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.setFocusOnField(field);
      };

      if (
        this.addInDataSource._array.length > 0 &&
        this.getTotalAddInQty > e.value
      ) {
        await showAlertAndReset(
          "You have attempted to set the WO Quantity to less than the add-in line total. Please enter a WO Quantity that is greater than or equal to add-in total",
          "Quantity"
        );
      } else if (this.model.SOQuantity === 0 && e.value === 0) {
        await showAlertAndReset(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a WO Quantity that is greater than 0.0000",
          "Quantity"
        );
      } else if (this.model.SOQuantity > 0 && e.value < this.model.SOQuantity) {
        await showAlertAndReset(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to ${this.model.SOQuantity}.`,
          "Quantity"
        );
      } else {
        this.model.MTSQuantity = e.value - this.model.SOQuantity;
      }
    },
    /**
     * MTS Qty value changed
     * @param e - event
     */
    async onMTSQuantityValueChanged(e) {
      let previousQtyValue = this.model.Quantity;
      this.model.Quantity = e.value + this.model.SOQuantity;

      if (this.model.Quantity === 0) {
        await this.$alert(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a MTS Quantity that is greater than 0.0000",
          "Validation Error"
        );
        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      } else if (
        this.model.SOQuantity > 0 &&
        this.model.Quantity < this.model.SOQuantity
      ) {
        await this.$alert(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to  ${this.model.SOQuantity}.`,
          "Validation Error"
        );

        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      } else {
        if (e.value === 0) {
          let instance = this.$refs["wo-so-line-grid"].instance;
          if (instance) {
            instance
              .byKey({
                SalesOrderCode: 0,
                SalesOrderLine: 0,
              })
              .then((res) => {
                if (res) {
                  instance.deselectRows([
                    {
                      SalesOrderCode: 0,
                      SalesOrderLine: 0,
                    },
                  ]);
                }
              });
          }
        }
      }
    },

    updateQtyFieldFromMTSQty(e, previousQtyValue) {
      e.component.beginUpdate();
      e.component.option("value", e.previousValue);
      e.component.endUpdate();

      this.model.Quantity = previousQtyValue;
      this.setFocusOnField("MTSQuantity");
    },

    onBOMSelectionChanged(e) {
      if (this.popupConfig.formMode !== "create")
        this.selectedBOMData = e.selectedItem;
    },

    async onProductSelectionChanged(e) {
      if (e.selectedItem) this.selectedProdData = { ...e.selectedItem };
      else this.selectedProdData = undefined;

      if (this.IsAddInFeatureEnabled) this.setAddInProdFilter();
    },
    async setAddInProdFilter() {
      this.addInProdFilter = [];
      this.addInProdFilter.push(["IsDefault", "=", "Y"]);
      // this.addInProdFilter.push("and");
      // this.addInProdFilter.push(["Available", ">", 0]);

      let settingValue = await SettingsService.getBySettingName(
        "WorkOrderAddInFinishedGoodType"
      );

      if (settingValue.data.value.length > 0) {
        this.addInProdFilter.push("and");
        this.addInProdFilter.push([
          "ProductTypeCode",
          "=",
          settingValue.data.value[0].SettingValue,
        ]);
      }

      let settingValue2 = await SettingsService.getBySettingName(
        "WorkOrderAddInFinishedGoodAssociation"
      );

      let filter = [];

      if (
        settingValue2.data.value.length > 0 &&
        this.selectedProdData !== undefined
      ) {
        if (settingValue2.data.value[0].SettingValue === "Product Category 1") {
          filter.push([
            "ProductCategory1Code",
            "=",
            this.selectedProdData.ProductCategory1Code,
          ]);
        } else if (
          settingValue2.data.value[0].SettingValue === "Product Category 2"
        ) {
          filter.push([
            "ProductCategory2Code",
            "=",
            this.selectedProdData.ProductCategory2Code,
          ]);
        } else if (
          settingValue2.data.value[0].SettingValue === "Product Category 3"
        ) {
          filter.push([
            "ProductCategory3Code",
            "=",
            this.selectedProdData.ProductCategory3Code,
          ]);
        } else if (
          settingValue2.data.value[0].SettingValue === "Product Category 4"
        ) {
          filter.push([
            "ProductCategory4Code",
            "=",
            this.selectedProdData.ProductCategory4Code,
          ]);
        }
      }

      if (filter.length > 0) {
        this.addInProdFilter.push("and");
        this.addInProdFilter.push(filter[0]);
      }

      if (this.model.Branch) {
        if (this.addInProdFilter.length > 0) this.addInProdFilter.push("and");
        this.addInProdFilter.push(["BranchCode", "=", this.model.Branch]);
      }

      if (!this.$refs["wo-add-in-grid"]) return;

      let dataGrid = this.$refs["wo-add-in-grid"].instance;
      let columns = dataGrid.option("columns");
      columns[0].editorOptions.dataSource = WorkOrderService.dataSourceConfig(
        "api/WorkOrderAddInItemCompanyBranch",
        {
          filter: this.addInProdFilter,
          postProcess: (data) => {
            // remove item when ItemCode is equal to this.PrimaryProductData.ItemCode from data array
            if (this.primaryProductData) {
              data = data.filter(
                (x) => x.ItemCode !== this.primaryProductData.ItemCode
              );
            }

            // add this.PrimaryProductData to the data array as the first item
            if (this.primaryProductData) {
              data.unshift(this.primaryProductData);
            }

            return data;
          },
        }
      );
      dataGrid.option("columns", columns);
    },
    onProductCodeSelected(e) {
      let itemData = e.selectedItem;
      let index = this.productDataSourceItems.findIndex(
        (x) => x.ItemCode === itemData.ItemCode
      );
      if (index === -1) {
        this.productDataSourceItems.push(itemData);
      }
    },
    onCommentKeyDown(e) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        e.event.preventDefault();
        if (this.selectedTabIndex === 0) {
          this.focusOnEditableCell(0, "ItemCode");
        } else if (this.selectedTabIndex === 1) {
          this.focusOnEditableCell(0, "Note");
        }
      }
    },
    onItemCodeKeyDown(e, lineData) {
      if (e.event.keyCode == 9 && e.event.shiftKey && lineData.rowIndex == 0) {
        e.event.preventDefault();
        var headerForm =
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
        if (headerForm) {
          headerForm.getEditor("Comments").focus();
        }
      }
    },
    onItemCodeClick(e, lineData) {
      if (e) this.focusOnEditableCell(lineData.rowIndex, "AddInStockUMQty");
    },

    commentFieldHeightUpdate(e) {
      let instance = e.component;
      let count = countLineBreaks(instance.instance().option().value);
      if (count < 7) {
        if (count > 2) {
          instance.instance().beginUpdate();
          instance.instance().option("height", count * 16);
          instance.instance().endUpdate();
          this.getDataGridInstance.updateDimensions();
        }
      } else {
        instance.instance().beginUpdate();
        instance.instance().option("height", 250);
        instance.instance().endUpdate();
        this.getDataGridInstance.updateDimensions();
      }
    },

    onProdQtyClicked(e) {
      this.releasePopupInfo.dataModel = e.data;
      this.releasePopupInfo.isPopupShow = true;
    },
  },
  computed: {
    getReleaseColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Product",
          dataField: "ProductCode",
          width: ColumnWidth.Code.width,
          minWidth: ColumnWidth.Code.minWidth,
          alignment: "left",
          allowSorting: true,
          sortOrder: "asc",
          sortIndex: 1,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          minWidth: ColumnWidth.Description.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          caption: "Release Date",
          dataField: "ReleaseDate",
          minWidth: ColumnWidth.Date.minWidth + 10,
          width: ColumnWidth.Date.width + 10,
          format: "dd MMM yyyy",
          allowSorting: true,
          sortOrder: "desc",
          sortIndex: 0,
        },
        {
          screenField: "SalesUM",
          caption: "Production UM",
          dataField: "ProductionUM",
          minWidth: ColumnWidth.ProductionUnitOfMeasure.minWidth,
          width: ColumnWidth.ProductionUnitOfMeasure.width,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "ProductionUMQty",
          caption: "Production UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          cellTemplate: "product-um-template",
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQty",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
          cellTemplate: "product-um-template",
        },
      ]);
    },
    ReleaseDataSource() {
      return WorkOrderService.dataSourceConfig("api/ReleaseDetailGrouped", {
        filter: `WorkOrderCode eq ${this.dataModel.Code}`,
      });
    },
    getDataGridInstance() {
      if (this.selectedTabIndex === 1) {
        return this.$refs["wo-so-line-grid"].instance;
      } else if (this.selectedTabIndex === 2) {
        return this.$refs["wo-meterials-grid"].instance;
      } else {
        return this.$refs["wo-add-in-grid"].instance;
      }
    },
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "BOM",
                  dataField: "BomCode",
                  required: true,
                  label: {
                    text: "BOM",
                  },
                  editorOptions: {
                    showClearButton: true,
                    readOnly: this.popupConfig.formMode === "edit",
                    tabIndex: this.popupConfig.formMode === "edit" ? -1 : 1,
                    onValueChanged: this.onBomValueChanged,
                    select: [
                      "Code",
                      "Comment",
                      "Description1",
                      "Description2",
                      "ProductCode",
                      "BatchSize",
                      "BranchCode",
                      "DivisionCode",
                      "BomTypeCode",
                      "Status",
                    ],
                    onSelectionChanged: (e) => {
                      this.onBOMSelectionChanged(e);
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description1}`;
                    else return undefined;
                  },
                  searchExpr: [
                    "Code",
                    "Description1",
                    "Description2",
                    "ProductCode",
                  ],
                },
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  required: true,
                  label: {
                    text: "Branch",
                  },
                  filter: ["ManufactureFlag", "=", "Y"],
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "Product",
                  dataField: "Product",
                  allowUpdate: true,
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                    onSelectionChanged: this.onProductSelectionChanged,
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description1}`;
                    else undefined;
                  },
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  required: true,
                  label: {
                    text: "Division",
                  },
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "Required",
                      label: {
                        text: "Required",
                      },
                      format: "dd MMM yyyy",
                      editorOptions: {
                        showClearButton: true,
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 3,
                        useMaskBehavior: true,
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        // min: new Date(),
                        // onValueChanged: (e) => {
                        //   if (e.event) {
                        //     if (e.value < new Date()) {
                        //       e.component.beginUpdate();
                        //       e.component.option("value", e.previousValue);
                        //       e.component.endUpdate();
                        //     }
                        //   }
                        // },
                      },
                      required: true,
                    },
                    {
                      visible: this.popupConfig.formMode === "review",
                      screenField: "DateIn",
                      dataField: "Scheduled",
                      label: {
                        text: "Scheduled",
                      },
                      format: "dd MMM yyyy",
                      editorOptions: {
                        tabIndex: 4,
                        useMaskBehavior: true,
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                      required: true,
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      dataField: "Quantity",
                      screenField: "WOQuantity",
                      allowUpdate: true,
                      required: true,
                      editorOptions: {
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 5,
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        min: this.model.SOQuantity,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onQuantityValueChanged(e);
                          }
                        },
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                    },
                    {
                      dataField: "MTSQuantity",
                      screenField: "MTSQuantity",
                      allowUpdate: true,
                      required: true,
                      editorOptions: {
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 6,
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        min: 0,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onMTSQuantityValueChanged(e);
                          }
                        },
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      dataField: "SOQuantity",
                      screenField: "SOQuantity",
                      editorOptions: {
                        tabIndex: -1,
                        readOnly: true,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 1,
                      items: [
                        {
                          dataField: "AddInStockUMQuantity",
                          screenField: "SOQuantity",
                          visible: this.IsAddInFeatureEnabled,
                          editorOptions: {
                            tabIndex: -1,
                            readOnly: true,
                          },
                          label: {
                            text: `Add In (${this.AddInStockUM})`,
                          },
                        },
                        {
                          dataField: "AddInSalesUMQuantity",
                          screenField: "SOQuantity",
                          visible: this.IsAddInFeatureEnabled,
                          editorOptions: {
                            tabIndex: -1,
                            readOnly: true,
                          },
                          label: {
                            text: `Add In (${this.AddInSalesUM})`,
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "Comments",
              screenField: "Comments",
              allowUpdate: true,
              editorType: "dxTextArea",
              editorOptions: {
                tabIndex: 8,
                height: 140,
                maxLength: 1000,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                onKeyDown: this.onCommentKeyDown,
              },
            },
          ],
        },
      ];
    },
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: false, // This work is being deferred at this time as legacy does not support background printing of work orders atm. #54380
          options: {
            icon: "print",
            // onClick: this.onBackGrounPrintRequest,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            icon: "pdffile",
            onClick: this.onPreviewPDF,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            this.popupConfig.isEditable,
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
            visible:
              this.popupConfig.formMode === "review" &&
              this.popupConfig.isEditable,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "create" ||
            (this.popupConfig.formMode != "review" &&
              this.FriendlyStatus === "Draft"),
          options: {
            text: "Draft",
            stylingMode: "contained",
            type: "normal",
            onClick: this.onDraftSave,
            visible:
              this.popupConfig.formMode === "create" ||
              (this.popupConfig.formMode != "review" &&
                this.FriendlyStatus === "Draft"),
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.onCancelPopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            items: this.getToolbarMenuItems,
            icon: "fas fa-ellipsis-v",
            showArrowIcon: false,
            stylingMode: "text",
            onItemClick: this.onToolbarMenuItemOnClick,
            dropDownOptions: {
              minWidth: 90, // Set minimum width for dropdown items
            },
            displayExpr: "menuText",
            valueExpr: "menuText",
          },
        },
      ];
    },
    getToolbarMenuItems() {
      return [
        {
          menuText: "Copy",
          visible: true, // pending discussions #54331
          onClick: this.onCopyWorkOrderHandler,
        },
        { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
      ];
    },
    getAddInGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Product",
          dataField: "ItemCode",
          fixed: true,
          fixedPosition: "left",
          cssClass: "edit-cell-textbox-field",
          // allowSearch: this.popupConfig.formMode == "review",
          // allowSorting: this.popupConfig.formMode == "review",
          // allowEditing: this.popupConfig.formMode != "review",
          editorOptions: {
            dataSource: WorkOrderService.dataSourceConfig(
              "api/WorkOrderAddInItemCompanyBranch",
              {
                filter: [],
              }
            ),
            displayExpr: "ItemCode",
            valueExpr: "ItemCode",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["ItemCode", "Description", "Description1"],
            onFocusIn: (e) => {
              e.event.target.select();
              this.productCodeFocusIn(e);
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.ItemCode}" >
                            <span class="auto-complete-primary">
                              ${data.ItemCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description1}
                            </span>
                          </div>`;
            },
            dropDownOptions: {
              minWidth: 400,
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
            onKeyDown: this.onItemCodeKeyDown,
            onItemClick: this.onItemCodeClick,
          },
          // eslint-disable-next-line no-unused-vars
          setCellValue: (newData, value, currentRowData) => {
            newData.ItemCode = value;

            let item = this.productDataSourceItems.find(
              (x) => x.ItemCode === value
            );

            let allowedTotal = this.model.Quantity - this.getTotalAddInQty;

            if (item) {
              newData.ItemDescription = item.Description1;
              newData.SalesUM = item.SalesUM;
              newData.StockUM = item.StockUM;
              newData.AddInStockUMQty =
                allowedTotal > item.Available ? item.Available : allowedTotal;
              newData.OnHand = item.OnHand;
              newData.OnHandSalesUMQty = item.OnHandSalesUMQty;
              newData.SalesUMConversion = item.SalesUMConversion;
              newData.RecordId = "00000000-0000-0000-0000-000000000000";
              newData.Available = item.Available;
              newData.AvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.OriginalAvailable = item.Available;
              newData.OriginalAvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.QtyValidation = true;

              if (newData.AddInStockUMQty === item.Available)
                newData.AddInSalesUMQty = item.AvailableSalesUMQty;
              else
                newData.AddInSalesUMQty = calculateSalesUMQty(
                  newData.AddInStockUMQty,
                  item.SalesUMConversion
                );
            }

            if (!currentRowData.ItemCode) this.addNewLineIntoProductEntry();

            return newData;
          },
          minWidth: ColumnWidth.TransactionAccount.minWidth,
          width: ColumnWidth.TransactionAccount.width,
        },
        {
          caption: "Description",
          dataField: "ItemDescription",
          allowEditing: false,
          minWidth: ColumnWidth.Description.minWidth,
        },

        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },

        // StockUM on hand
        // {
        //   screenField: "Quantity",
        //   dataField: "OnHand",
        //   caption: "On Hand",
        //   minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        //   width: ColumnWidth.Quantity4DecimalPoints.width,
        //   allowSorting: true,
        // },
        {
          screenField: "Quantity",
          dataField: "Available",
          caption: "Available",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        // StockUM Add In
        {
          dataField: "AddInStockUMQty",
          caption: "Add In",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
              // this.addInDataSource.update(lineData.data.ID, {
              //   QtyValidation: true,
              // });
            },
            // onFocusOut: async (e, lineData) => {
            //   console.log(
            //     "A ## : ",
            //     lineData.data.QtyValidation,
            //     this.getTotalAddInQty
            //   );
            //   return;
            //   if (!e.event) return;

            //   if (lineData.data.QtyValidation) {
            //     if (this.getTotalAddInQty > this.model.Quantity) {
            //       let alert = await this.$alert(
            //         `Add In stock quantity total can not be greater than WO quantity`,
            //         "Validation Error"
            //       );

            //       if (alert) {
            //         this.addInDataSource.update(lineData.data.ID, {
            //           AddInStockUMQty: lineData.data.Available,
            //           AddInSalesUMQty: lineData.data.AvailableSalesUMQty,
            //           QtyValidation: false,
            //         });
            //         this.$nextTick(() => {
            //           this.reFocusOnQty(lineData.data, "AddInStockUMQty");
            //         });
            //       }
            //     }
            //   }
            // },
            // onInput: (e, lineData) => {
            //   console.log("onInput : ", e);
            //   if (e.event)
            //     this.addInDataSource.update(lineData.data.ID, {
            //       QtyValidation: true,
            //     });
            // },
            // to do update sales um qty
          },
          setCellValue: async (newData, value, currentRowData) => {
            // this.addInDataSource.update(currentRowData.ID, {
            //   QtyValidation: false,
            // });
            if (value < 0) {
              let alert = await this.$alert(
                `Add In stock quantity can not be less than 0.00`,
                "Validation Error"
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                });
              }
            } else if (value > currentRowData.Available) {
              let alert = await this.$alert(
                `Add In stock quantity is greater than Available Add-In quantity.`,
                "Validation Error"
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                });
              }
            } else if (
              value + this.getTotalAddInQty - currentRowData.AddInStockUMQty >
              this.model.Quantity
            ) {
              let alert = await this.$alert(
                `Add In stock quantity total can not be greater than WO quantity`,
                "Validation Error"
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                  });
                }, 1);
              }
            } else {
              newData.QtyValidation = false;
              newData.AddInStockUMQty = value;
              newData.AddInSalesUMQty = calculateSalesUMQty(
                value,
                currentRowData.SalesUMConversion
              );
            }
          },
        },

        {
          screenField: "SalesUM",
          caption: "Sales UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },

        // SalesUM on hand
        // {
        //   screenField: "Quantity",
        //   dataField: "OnHandSalesUMQty",
        //   caption: "On Hand",
        //   minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        //   width: ColumnWidth.Quantity4DecimalPoints.width,
        //   allowSorting: true,
        // },
        {
          screenField: "Available",
          dataField: "AvailableSalesUMQty",
          cpation: "Available",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },

        // SalesUM add on
        {
          dataField: "AddInSalesUMQty",
          caption: "Add In",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // to do update stock um qty
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (value < 0) {
              let alert = await this.$alert(
                `Add In sales quantity can not be less than 0.00`,
                "Validation Error"
              );
              if (alert) {
                newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                });
              }
            } else if (value > currentRowData.AvailableSalesUMQty) {
              let alert = await this.$alert(
                `Add In sales quantity is greater than Available Add-In quantity.`,
                "Validation Error"
              );
              if (alert) {
                newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                });
              }
            } else {
              let stockQty = calculateStockUMQty(
                value,
                currentRowData.SalesUMConversion
              );

              if (
                stockQty -
                  currentRowData.AddInStockUMQty +
                  this.getTotalAddInQty >
                this.model.Quantity
              ) {
                let alert = await this.$alert(
                  `Add In stock quantity total can not be greater than WO quantity`,
                  "Validation Error"
                );
                if (alert) {
                  newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                  setTimeout(() => {
                    this.$nextTick(() => {
                      this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                    });
                  }, 10);
                }
              } else {
                newData.AddInSalesUMQty = value;
                newData.AddInStockUMQty = calculateStockUMQty(
                  value,
                  currentRowData.SalesUMConversion
                );
              }
            }
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          visible: this.popupConfig.formMode !== "review",
          buttons: [
            {
              hint: "Add Line",
              icon: "plus",
              visible: true,
              onClick: () => {
                this.addNewLineIntoProductEntry(false, "new-line");
              },
            },
            "delete",
          ],
          fixed: true,
          fixedPosition: "right",
        },
      ]);
    },
    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Sales Order",
          dataField: "SalesOrderCode",
          width: ColumnWidth.SalesOrderNumber.width - 10,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth - 10,
          alignment: "left",
          allowEditing: false,
        },
        {
          screenField: "Customer",
          allowSorting: true,
        },
        {
          screenField: "LineComment",
          caption: "Line #",
          dataField: "SalesOrderLine",
          width: ColumnWidth.LineInfo.width - 20,
          minWidth: ColumnWidth.LineInfo.minWidth - 20,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          dataField: "SalesOrderShipDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "Product",
          caption: "Product",
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "SalesUMQuantity",
          caption: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "SalesUM",
          caption: "Sales UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQuantity",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "right",
          visible: this.getAddSOLineBtnVisibility,
          width: 30,
          minWidth: 30,
        },
        {
          screenField: "Comment",
          dataField: "SalesOrderNote",
          caption: "Sales Order Notes",
          // cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            readOnly: true,

            // onInitialized: (e) => {
            //   this.commentFieldHeightUpdate(e);
            // },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
        {
          screenField: "Comment",
          dataField: "Note",
          caption: "Work Order Notes",
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onItemCodeKeyDown,
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          setCellValue: (newData, value) => {
            newData.Note = value;
            return newData;
          },
        },
      ]);
    },
    getWorkOrderMaterialColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Process",
          dataField: "ProcessCode",
          width: ColumnWidth.DeliveryNumber.width,
          minWidth: ColumnWidth.DeliveryNumber.minWidth,
          alignment: "left",
          allowSorting: true,
          cssClass: "process-code",
        },
        {
          caption: "Product",
          dataField: "ProductCode",
          width: ColumnWidth.Code.width,
          minWidth: ColumnWidth.Code.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          caption: "Description",
          dataField: "Description",
          minWidth: ColumnWidth.Description.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          alignment: "left",
          width: ColumnWidth.DeliveryNumber.width,
          minWidth: ColumnWidth.DeliveryNumber.minWidth,
          allowSorting: true,
        },
        {
          caption: "WO Qty",
          dataField: "WorkOrderQty",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          allowSorting: true,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Act Qty",
          dataField: "ActualQty",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          allowSorting: true,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "OS Qty",
          dataField: "OutstandingQty",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          allowSorting: true,
          cssClass: "os-qty",
          format: "##,###,###,###,##0.0000",
        },
      ]);
    },

    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getAddInLocalDataSource() {
      return this.addInDataSource;
    },

    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getLocalDataSource() {
      return this.soLinesDataSource;
    },

    getAddSOLineBtnVisibility() {
      return this.popupConfig.formMode !== "review";
      // if (this.popupConfig.formMode === "review") return false;
      // else if (this.popupConfig.formMode !== "create" && this.dataModel.FriendlyStatus === "In Production")
      //   return false;
      // else return true;
    },

    getTotalAddInQty() {
      return this.addInDataSource._array.reduce(
        (prev, curr) => prev + curr.AddInStockUMQty,
        0.0
      );
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-work-order {
  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: white;
    margin: 0px 10px;

    .wo-so-toolbar {
      .dx-icon.dx-icon-plus::before {
        color: #03a9f4;
      }
    }
  }

  .wo-so-lines {
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .process-code {
    padding-left: 10px !important;
  }

  .os-qty {
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-editor-cell.dx-focused {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
}
</style>
